export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center px-6 bg-[#0a0a0a]">
      <div className="text-orange-500 font-display text-8xl font-bold mb-4">404</div>
      <h1 className="font-display text-4xl font-bold text-white uppercase mb-4">Page Not Found</h1>
      <p className="text-gray-400 mb-8 text-lg">The page you're looking for doesn't exist.</p>
      <a
        href="/"
        className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded-lg font-bold transition-all duration-200 inline-flex items-center gap-2"
      >
        <i className="ri-home-line"></i> Back to Home
      </a>
      <p className="mt-8 text-gray-500 text-sm">
        Need a quote? Call us at{' '}
        <a href="tel:262-215-0688" className="text-orange-400 hover:text-orange-300">(262) 215-0688</a>
      </p>
    </div>
  );
}
